import ServiceExec from '@/common/utils/ServiceExec';
// import { forEach } from 'lodash'
/**
 * 뱅크다이어리 고객 관리 관련 API Service
 * @class ManageSvc
 */
class ManageSvc extends ServiceExec {
  /**
   *  전문가 고객신청 리스트 가져오기
   *  @param Authorization {string} Authorization
   *  @param limit {integer}
   *  @param page {integer}
   *  @param searchTextForExpert {integer} 검색어
   */
  getMatchingUserList(params = {}) {
    return this.get(`/api/expert/matching/user`, params).then((response) => {
      return response.data;
    });
  }

  /**
   *  전문가 고객신청 상세 가져오기
   *  @param Authorization {string} Authorization
   *  @param matchingNo {integer}
   */
  getMapMatching({ matchingNo }) {
    return this.get(`/api/expert/matching/${matchingNo}`).then((response) => {
      return response.data;
    });
  }

  getActualLossPaymentList({ matchingNo }) {
    return this.get(`/api/expert/matching/${matchingNo}/actual-loss-payment`).then((response) => {
      return response.data;
    });
  }

  getHometaxMonthlyClaimHistory({ matchingNo }) {
    return this.get(`/api/expert/matching/${matchingNo}/hometax/claim-history/monthly`).then((response) => {
      return response.data;
    });
  }

  getHiraMedicalInfoList({ matchingNo }) {
    return this.get(`/api/expert/matching/${matchingNo}/hira/medical-info`).then((response) => {
      return response.data;
    });
  }

  getHiraMedicationList({ matchingNo }) {
    return this.get(`/api/expert/matching/${matchingNo}/hira/medication`).then((response) => {
      return response.data;
    });
  }

  getInsuranceClaimList({ matchingNo }) {
    return this.get(`/api/expert/matching/${matchingNo}/insurance-claim`).then((response) => {
      return response.data;
    });
  }

  getAllInsuranceClaimList(params = {}) {
    return this.get(`/api/expert/insurance/claim/all`, params).then((response) => {
      return response.data;
    });
  }

  getInsuranceClaimCompanyList() {
    return this.get(`/api/expert/insurance/claim/companies`).then((response) => {
      return response.data;
    });
  }

  updateInsuranceClaimConsultationStatus(insuranceClaimNo, status) {
    return this.patch(`/api/expert/insurance/claim/${insuranceClaimNo}/consultation-status`, { status }).then(
      (response) => response.data
    );
  }

  getInsuranceClaimConsultationMemo(insuranceClaimNo) {
    return this.get(`/api/expert/insurance/claim/${insuranceClaimNo}/consultation-memo`).then((response) => {
      return response.data;
    });
  }

  updateInsuranceClaimConsultationMemo(insuranceClaimNo, memo) {
    return this.patch(`/api/expert/insurance/claim/${insuranceClaimNo}/consultation-memo`, { memo }).then(
      (response) => response.data
    );
  }

  /**
   *  고객 삭제
   *  @param Authorization {string} Authorization
   *  @param matchingNo {integer} matchingNo
   */
  deleteIntMatching(params = {}) {
    return this.delete(`/api/expert/manage/deleteIntMatching`, params).then((response) => {
      return response.data;
    });
  }

  /**
   *  임의입력(오프라인 고객)등록
   *  @param Authorization {string} Authorization
   *  @param expertOffMatchingDTO {ExpertOffMatchingDTO} expertOffMatchingDTO
   */
  postIntMatching(params = {}) {
    return this.post(`/api/expert/matching/offline-user`, params).then((response) => {
      return response.data;
    });
    // return this.post(`/api/expert/manage/deleteIntMatching`, params).then((response) => {
    //   return response.data;
    // });
  }

  /**
   *  고객상세(보험 불러오기)
   *  @param Authorization {string} Authorization
   *  @param matchingNo {integer}
   */
  loadCustomerInsurance({ matchingNo }) {
    return this.post(`/api/expert/matching/${matchingNo}/insurance`).then((response) => {
      return response.data;
    });
  }

  /**
   *  고객상세(컨설팅 내역) 가져오기
   *  @param Authorization {string} Authorization
   *  @param matchingNo {integer}
   */
  getListMatchingPlan({ matchingNo }) {
    return this.get(`/api/expert/matching/${matchingNo}/plan`).then((response) => {
      return response.data;
    });
    // return this.get(`/api/expert/manage/getListMatchingPlan`, params).then((response) => {
    //   return response.data;
    // });
  }

  /**
   *  고객상세(고객 보험리스트 불러온 내역 -> 컨설팅 내역 복사)
   *  @param Authorization {string} Authorization
   *  @param matchingInsrnNos {array} matchingInsrnNos
   *  @param matchingNo {integer}
   */
  getIntCopyInsrnToPlan({ matchingNo, matchingInsuranceNo }) {
    return this.post(`/api/expert/matching/${matchingNo}/insurance/${matchingInsuranceNo}/copy`).then((response) => {
      return response.data;
    });
    // return this.get(`/api/expert/manage/getIntCopyInsrnToPlan`, params).then((response) => {
    //   return response.data;
    // });
  }

  /**
   *  고객상세(컨설팅 내역 -> 고객 보험리스트 불러온 내역 복사)
   *  @param Authorization {string} Authorization
   *  @param matchingNo {integer}
   *  @param matchingPlanNos {array} matchingPlanNos
   */
  getIntCopyPlanToInsrn({ matchingNo, matchingPlanNo }) {
    return this.post(`/api/expert/matching/${matchingNo}/plan/${matchingPlanNo}/copy`).then((response) => {
      return response.data;
    });
    // return this.get(`/api/expert/manage/getIntCopyPlanToInsrn`, params).then((response) => {
    //   return response.data;
    // });
  }

  /**
   *  고객상세(고객 보험리스트 불러온 내역) 가져오기
   *  @param Authorization {string} Authorization
   *  @param matchingNo {integer}
   */
  getListMatchingInsrn({ matchingNo }) {
    return this.get(`/api/expert/matching/${matchingNo}/insurance`).then((response) => {
      return response.data;
    });
  }

  /**
   *  보험 내역 수기 입력/수정
   *  @param Authorization {string} Authorization
   *  @param expertPassiveInsrnDTO {ExpertPassiveInsrnDTO} expertPassiveInsrnDTO
   */
  postIntPassiveMatchingInsrn(params = {}) {
    return this.post(`/api/expert/matching/${params.matchingNo}/insurance/${params.matchingInsuranceNo}`, params).then(
      (response) => {
        return response.data;
      }
    );
    // return this.post(`/api/expert/manage/postIntPassiveMatchingInsrn`, params).then((response) => {
    //   return response.data;
    // });
  }

  /**
   *  컨설팅 수기 입력/수정
   *  @param Authorization {string} Authorization
   *  @param expertPassivePlanDTO {ExpertPassivePlanDTO} expertPassivePlanDTO
   */
  postIntPassiveMatchingPlan(params = {}) {
    return this.post(`/api/expert/matching/${params.matchingNo}/plan/${params.matchingPlanNo}`, params).then(
      (response) => {
        return response.data;
      }
    );
    // return this.post(`/api/expert/manage/postIntPassiveMatchingPlan`, params).then((response) => {
    //   return response.data;
    // });
  }

  /**
   *  고객상세(컨설팅 내역 + 보장항목) 가져오기
   *  @param Authorization {string} Authorization
   *  @param mathcingPlanNo {integer}
   */
  getMapMatchingPlanItem({ matchingNo, matchingPlanNo }) {
    return this.get(`/api/expert/matching/${matchingNo}/plan/${matchingPlanNo}`).then((response) => {
      return response.data;
    });
    // return this.get(`/api/expert/manage/getMapMatchingPlanItem`, params).then((response) => {
    //   return response.data;
    // });
  }

  /**
   *  고객상세(고객 보험리스트 불러온 내역 + 보장항목) 가져오기
   *  @param Authorization {string} Authorization
   *  @param matchingNo {integer}
   *  @param matchingInsuranceNo {integer}
   */
  getMapMatchingInsrnItem({ matchingNo, matchingInsuranceNo }) {
    return this.get(`/api/expert/matching/${matchingNo}/insurance/${matchingInsuranceNo}`).then((response) => {
      return response.data;
    });
  }

  /**
   *  보험 내역 삭제
   *  @param Authorization {string} Authorization
   *  @param matchingInsrnNo {integer} matchingInsrnNo
   */
  deleteIntMatchingInsrn({ matchingNo, matchingInsuranceNo }) {
    return this.delete(`/api/expert/matching/${matchingNo}/insurance/${matchingInsuranceNo}`).then((response) => {
      return response.data;
    });
    // return this.delete(`/api/expert/manage/deleteIntMatchingInsrn`, params).then((response) => {
    //   return response.data;
    // });
  }

  /**
   *  컨설팅 삭제
   *  @param Authorization {string} Authorization
   *  @param matchingPlanNo {integer} matchingPlanNo
   */
  deleteIntMatchingPlan({ matchingNo, matchingPlanNo }) {
    return this.delete(`/api/expert/matching/${matchingNo}/plan/${matchingPlanNo}`).then((response) => {
      return response.data;
    });
    // return this.delete(`/api/expert/manage/deleteIntMatchingPlan`, params).then((response) => {
    //   return response.data;
    // });
  }

  /**
   *  컨설팅 보험 추가/미추가
   *  @param Authorization {string} Authorization
   *  @param isAdd {integer} isAdd
   *  @param matchingPlanNo {integer} matchingPlanNo
   */
  updateIsAdd(params = {}) {
    return this.patch(`/api/expert/matching/${params.matchingNo}/plan/${params.matchingPlanNo}/add`, params).then(
      (response) => {
        return response.data;
      }
    );
    // return this.get(`/api/expert/manage/updateIsAdd`, params).then((response) => {
    //   return response.data;
    // });
  }

  /**
   *  보유중인 보험 미해지/해지
   *  @param Authorization {string} Authorization
   *  @param isTermination {integer} isTermination
   *  @param matchingInsrnNo {integer} matchingInsrnNo
   */
  updateIsTermination(params = {}) {
    return this.patch(
      `/api/expert/matching/${params.matchingNo}/insurance/${params.matchingInsuranceNo}/termination`,
      params
    ).then((response) => {
      return response.data;
    });
    // return this.get(`/api/expert/manage/updateIsTermination`, params).then((response) => {
    //   return response.data;
    // });
  }

  // /**
  //  * 보장분석 PDF 파일 다운로드
  //  * @param params
  //  * @returns {Promise<any> | Thenable<any> | PromiseLike<any>}
  //  */
  // getPdfFile(params = {}) {
  //   return this.downloadStream(`/api/expert/manage/getPdfFile`, params).then(
  //     response => {
  //       return response
  //     }
  //   )
  // }

  /**ㅍ
   * 보장분석 PDF 파일 가져오기
   * @param params
   * @returns {Promise<any> | Thenable<any> | PromiseLike<any>}
   */
  getPdfFile(params = {}) {
    return this.get(`/api/expert/matching/${params.matchingNo}/pdf`, params).then((response) => {
      return response.data;
    });
    // return this.get(`/api/expert/manage/getPdfFile`, params).then((response) => {
    //   return response.data;
    // });
  }

  /**
   *  보험 불러오기 전 불러오기 카운팅 가져오기
   *  @param Authorization {string} Authorization
   *  @param matchingNo {integer}
   */
  getIntLoadCnt(params = {}) {
    return this.get(`/api/expert/manage/getIntLoadCnt`, params).then((response) => {
      return response.data;
    });
  }

  /**
   *  보험 초기화
   *  @param Authorization {string} Authorization
   *  @param matchingNo {integer} matchingNo
   */
  deleteIntMatchingInsrnAll({ matchingNo }) {
    return this.delete(`/api/expert/matching/${matchingNo}/insurance`).then((response) => {
      return response.data;
    });
    // return this.delete(`/api/expert/manage/deleteIntMatchingInsrnAll`, params).then((response) => {
    //   return response.data;
    // });
  }
}
export default new ManageSvc();
